<template>
  <div class="employeeLIstVue">
    <!-- Main Body Content area -->
    <div class="o-main-content-area o-main-content-area--padBotoomNone">
        <!-- Heading Section -->
        <div class="row c-responsive-fixwidth">
            <div class="col-md-12">
                <h1 class="h1 text-center">Employee Merger Form</h1>
            </div>
        </div>
        <!-- /Heading Section -->
    </div>

    <div class="o-ndividualArea c-responsive-fixwidth">
      <div class="col-md-6 col-md-offset-3">
          <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white fix-height" v-loading="employeesLoading">
              <div class="row">
                  <div v-if="userRoleSlug=='super-admin'" class="col-sm-12">
                      <div class="form-group" v-loading="employeesLoading">
                          <label class="common-label-text o-super-label">Select Client:</label>                     
                          <el-select
                            v-model="selectedClient"
                            filterable
                            remote
                            value-key="id"
                            style="width: 100%;"
                            placeholder="Select a Client"
                            @change="onSelectClient">
                            <el-option
                              v-for="client in clientList"
                              :key="client.id"
                              :label="client.subdomain"
                              :value="client">
                            </el-option>
                          </el-select>
                      </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group ">
                      <label class="common-label-text o-super-label">Select Employee Source A:</label>
                      <el-select
                        v-model="mergerForm.sourceEmployee"
                        filterable
                        remote
                        reserve-keyword
                        style="width: 100%;"
                        placeholder="Please Enter Employee First Name or Last Name">
                        <el-option
                          v-for="emp in employeesList"
                          :key="emp.id"
                          :label="emp.first_name + ' ' + emp.last_name + ' ' + getEmployeeMergeNotes(emp) + '-' + emp.name"
                          :value="emp.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                      <div class="form-group ">
                          <label class="common-label-text o-super-label">Select Employee Target B:</label>
              
                                  <el-select
                                    v-model="mergerForm.targetEmployee"
                                    filterable
                                    remote
                                    reserve-keyword
                                    value-key="id"
                                    style="width: 100%;"
                                    placeholder="Please Enter Employee First Name or Last Name">
                                    <el-option
                                      v-for="emp in employeesList"
                                      :key="emp.id"
                                      :label="emp.first_name + ' ' + emp.last_name + ' ' + getEmployeeMergeNotes(emp) + '-' + emp.name"
                                      :value="emp.id">
                                    </el-option>
                                  </el-select>
                            
                      </div>
                  </div>
              </div>

              <a href="javascript: void(0)" @click="mergeEmployee()" class="c-solid-btn c-solid-btn--green">Merge Employee</a>

              <div class="mt-20">
                <sup class="note-label">
                  Note: 
                </sup>
                <ul>
                  <li class="mt-5">
                  This script will merge 2 accounts within the same client.
                  </li>
                  <li class="mt-5">
                  The following data will merge or append to the target: jobs, calls, notes, documents, vacations.
                  </li>
                  <li class="mt-5">
                  The following data will be updated to the target: the lowest seniority, the oldest date of hire, and the oldest member since.</li>
                  <li>
                  </li>
                  <li class="mt-5">
                  The status of the target will survive.
                  </li>
                </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    // import dateTimeConvert from '../../../timeConvert&Compare.js';
    // import {
    //     VueEditor
    // } from 'vue2-editor';
    import service from '../../../services.js';
    // import { global } from '../../../global.js';
    let timeout = null;
    export default {
        // components: {
        //     VueEditor
        // },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
            }),    
        },
        data() {
          return { 
            employeesLoading: false,
            clientList: [],
            savedClients: [],
            employeeList: [],
            savedEmployees: [], 
            employeesList: [],
            mergerForm: {
              client: "",
              sourceEmployee: "",
              targetEmployee: ""
            },
            selectedClient: null,
            selectedClientId: "", //id
            selectedClientSort: "",     //default_employee_sort  
            selectedClientContextRole: "", //cs3-context-role : user.role_id
            next_page: "",
            afterApi: "",
            loading: false
          };
        },
        beforeMount() {},
        methods: {
          async getClientList() {
            this.$Progress.start();
            this.loading=true;
            await service.get('client', {
              'Authorization': this.userToken
            })
            .then(async (res) => {
              this.$Progress.finish();
              this.clientList = res.data.result;
              this.next_page_url = res.data.result.next_page_url;
              this.loading=false;
              if (res.data.result.next_page_url != null) {
                  await service.get('client', {
                    'Authorization': this.userToken
                  })
                  .then((newClients) => {
                    this.savedClients = newClients.data.result;
                    this.next_page_url = null;
                  }).catch((err) => {
                    console.log(err);
                  });
              }
            }).catch((err) => {
                console.log(err);
            });
          },

          getEmployeeMergeNotes(emp) {
            if(emp.merge_notes) {
              return emp.merge_notes
            }
            return ""
          },

          async onSelectClient() {
            // console.log(this.selectedClient);
            this.selectedClientId = this.selectedClient.id; //id
            this.selectedClientSort = this.selectedClient.default_employee_sort  
            this.selectedClientContextRole = this.selectedClient.user.role_id
            this.mergerForm.sourceEmployee = "";
            this.mergerForm.targetEmployee = "";  
            await this.getAllEmployee();
            this.mergerForm.client = this.selectedClientId;
          },

          async getAllEmployee() {
            this.$Progress.start();
            this.loading = true;
            this.afterApi = false;
            this.employees=[];
            this.savedEmployees =[]; 
            this.employeesLoading = true;
            await service.get('employee/clientEmployees', {
                'cs3-context-clientId': this.selectedClientId,   
                'Authorization': this.userToken,
                'cs3-context-role': this.selectedClientContextRole,
                // 'status': this.selectedStatusId,
                'clientId': this.selectedClientId,
                'sort': this.selectedClientSort,
            }).then((res) => {
                // console.log('clientEmployees', res);
                this.employeesList = res.data.result;
                this.$Progress.finish(); 
                this.loading = false;
                this.employeesLoading = false;
            }).catch((err) => {
                console.log(err);
                this.loading = false;
                this.afterApi = true;
            });
            this.employeesLoading = false;
          },

          async mergeEmployee() {
            // console.log(this.mergerForm);  
            // if(userRoleSlug != 'super-admin'){
            //   this.selectedClientId = this.userClientID;
            //   this.mergerForm.client = this.userClientID;
            // }
            this.employeesLoading = true;
            await service.post('superadmin/mergeEmployee', {
                'client_id': this.mergerForm.client,
                'old_employee_id': this.mergerForm.sourceEmployee,
                'new_employee_id': this.mergerForm.targetEmployee
            }, {
                'Authorization': this.userToken,
                'cs3-context-role': this.selectedClientContextRole,
                'cs3-context-clientId': this.selectedClientId
            }).then((res) => {
                this.employeesLoading = false;
                this.$notify({
                    title: this.$t('success'),
                    message: 'Employee Merge Successfully.',
                    type: 'success'
                });                    
                this.mergerForm.client = "";
                this.mergerForm.sourceEmployee = "";
                this.mergerForm.targetEmployee = "";                    
            }).catch((err) => {
                console.log(err);
                //  this.employeesLoading = false;
            });  
            this.employeesLoading = false;      
          }, 
        }, 
        
        async created() {
          if(this.userRoleSlug != 'super-admin'){
            this.selectedClientId = this.userClientID;
            await this.getAllEmployee();
            this.mergerForm.client = this.selectedClientId;
          }else{
            await this.getClientList();
          }
        }

    }

</script>
<style scoped>
.note-label {
  font-weight: 600;
  color: red;
}
.mt-20 {
  margin-top: 20px;
}
.mt-5 {
  margin-top: 5px;
}
.fix-height{
  min-height: 50px;
}
</style>

